<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import MediaComponent from "@components/common/Media.svelte";
	import type { EmblaCarouselType } from "embla-carousel";
	import autoscroll from "embla-carousel-auto-scroll";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { Media } from "@core/schema/Media.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	let api = $state<EmblaCarouselType>();

	const id = $props.id();
	const { data, lightboxId = id }: ContentBlockComponentProps<ContentType.Gallery> = $props();

	function stopAutoscroll(): void {
		api?.plugins().autoScroll.stop();
	}
	function playAutoscroll(): void {
		api?.plugins().autoScroll.play();
	}
</script>

<div
	role="presentation"
	class="full-width w-full contain-inline-size max-w-[calc(var(--container-width)-2rem)] mx-auto"
	ontouchstart={stopAutoscroll}
	onmouseenter={stopAutoscroll}
	onmouseleave={playAutoscroll}
>
	<Carousel
		bind:api
		class="max-w-[100cqw] bg-white py-4 rounded-2xl mx-auto border-x-[1rem] border-white"
		items={data.images}
		options={{ loop: true, align: "start" }}
		plugins={[autoscroll({ playOnInit: true, stopOnMouseEnter: true, startDelay: 0 })]}
	>
		{#snippet item(image: Media)}
			<div class="mx-2 shrink-0">
				<MediaComponent
					source={image}
					class="object-cover rounded-lg size-full"
					alt={image.title ?? ""}
					height={300}
					width={400}
					sourcesets={{
						"<lg": [300, 400],
						">lg": [300, 400],
					}}
					lightbox={lightboxId}
					wrapperClass="max-w-[18.75rem] lg:max-w-[25rem] w-full block aspect-[4/3] h-[14rem] lg:h-[18.75rem] "
				/>
			</div>
		{/snippet}
	</Carousel>
</div>
